import React, { useEffect, useState } from 'react'

import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import {
  BarLoader,
  Button,
  IconButton,
  Pagination,
  usePagination,
} from '@st-operations/uikit/src/v2'

import Table from '../table'
import DetailsModal from '../details-modal'

import { getEnterpriseRequests, enterpriseResendEmail } from '_services/predactiv-admin'

const EnterpriseTab = ({ env }) => {
  const [data, setData] = useState(null)
  const [viewing, setViewing] = useState(null)

  const getItems = (response) =>
    response?.map((item) => ({
      data: item,
      values: [item.name, item.email, item.company_name],
    }))
  const items = getItems(data)
  const { page, toPage } = usePagination(items || [], 15)

  useEffect(() => {
    setData(null)
    setViewing(null)
    getEnterpriseRequests(env)
      .then((resp) => setData(resp))
      .catch((err) => console.error('err', err))
  }, [env])

  const renderAction = (data) => (
    <>
      <IconButton
        onClick={() => setViewing(data)}
        aria-label="View Details"
        iconProps={{
          icon: 'info',
          type: 'outline',
          width: 16,
          height: 16,
          color: '#3D3C68',
        }}
      />
    </>
  )

  const handleResend = () => {
    enterpriseResendEmail({ env, id: viewing._id })
      .then(() => toast.success('Email sent!'))
      .catch(() => toast.error('An error has occurred'))
  }

  if (!data) return <BarLoader />

  return (
    <div>
      <Table
        items={page.content}
        header={['Name', 'Email', 'Organization']}
        renderAction={renderAction}
        gridTemplateColumns={'repeat(3, 1fr) min-content'}
      />
      <Pagination
        options={{ length: page.quantity }}
        page={page.number - 1}
        onPageChange={(page) => toPage(page.label)}
      />
      <Dialog open={!!viewing} onClose={() => setViewing(null)}>
        <DetailsModal
          env={env}
          data={viewing}
          actions={[
            <Button key={1} onClick={handleResend}>
              Resend Email
            </Button>,
          ]}
        />
      </Dialog>
    </div>
  )
}

export default EnterpriseTab
